import { render, staticRenderFns } from "./UkrTreasuresCreateUser.vue?vue&type=template&id=23ec0da1&scoped=true"
import script from "./UkrTreasuresCreateUser.vue?vue&type=script&lang=js"
export * from "./UkrTreasuresCreateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ec0da1",
  null
  
)

export default component.exports